module.exports = __webpack_public_path__ + "media/crash_video_02.9bdca6c9.mp4";